import { Icon } from "@trueskin-web/components"
import { checkIcon } from "@trueskin-web/theme/icons/checkIcon"

import Plan from "../../shared/choose-plan/plan"

const SubscriptionService = ({ children }) => (
  <li sx={{ display: "inline-flex", columnGap: 1 }}>
    <Icon icon={checkIcon} color="primary" />
    {children}
  </li>
)

const Subscriptions = ({ subscription, plans, selectedPlanId, onSelect }) => (
  <div
    sx={{
      p: 4,
      background: "white",
      borderRadius: "8px",
    }}
    data-component-name="PlanSelectionSubscriptionPlans"
  >
    <div
      sx={{
        fontFamily: "display",
        fontSize: 4,
        lineHeight: 1.4,
      }}
    >
      {subscription.title}
    </div>

    <ul
      sx={{
        mt: 4,
        mb: 5,
        pl: 0,
        listStyle: "none",
        fontSize: 1,
        "&>li:not(:first-child)": {
          mt: 2,
        },
      }}
    >
      {subscription.details.map((text, index) => (
        <SubscriptionService key={index}>{text}</SubscriptionService>
      ))}
    </ul>

    <div
      sx={{
        display: "grid",
        gap: 4,
      }}
    >
      {plans.map((plan) => (
        <Plan
          key={plan.id}
          plan={plan}
          selectedPlanId={selectedPlanId}
          onSelect={onSelect}
        />
      ))}
    </div>
  </div>
)

export default Subscriptions
